import { Button, IconButton, TextField, Select, MenuItem, FormControl, InputLabel, Chip, Box, OutlinedInput, SelectChangeEvent, Checkbox, ListItemText } from "@mui/material";
import { useEffect, useState } from "react";
import { HiMiniLanguage } from "react-icons/hi2";
import { useNavigate, useParams } from "react-router-dom";
import { iLocation, Location as LocationModel } from "../../models/Location";
import api from "../../services/axios-client";
import { IGeoFence } from "../../models/GeoFence";
import CircularWithValueLabel from "../../components/CircularWithValueLabel";
import { uploadAsset } from "../../utilities/assetUtils";
import { ASSETS_PATH } from "../../constants";
import { createPortal } from "react-dom";
import PopLanguages from "../../components/PopLanguages";
import PopNarations from "../../components/PopNarations";
import { on } from "events";
import Swal from 'sweetalert2';


const Location = () => {
  const locationId = useParams().location_id;
  const navigate = useNavigate();
  const [location, setLocation] = useState<iLocation>(new LocationModel());
  const [uploading, setUploading] = useState<boolean>(false);
  const [progress, setProgress] = useState<number>(0);
  const [locationNamePop, setLocationNamePop] = useState<boolean>(false);
  const [locationAboutAudioPop, setLocationAboutAudioPop] = useState<boolean>(
    false
  );
  const [locationExtendedAudioPop, setLocationExtendedAudioPop] = useState<boolean>(
    false
  );
  const [allFences, setAllFences] = useState<IGeoFence[]>([]);

  useEffect(() => {
    if (locationId !== "0") {
      fetchLocation();
    }
    fetchAllFences();
  }, [locationId]);

  const fetchAllFences = async () => {
    try {
      const response = await api.get("/geofences");
      if (response.data.success) {
        setAllFences(response.data.geoFences);
      }
    } catch (error) {
      console.error("Failed to fetch geofences:", error);
    }
  };

  const fetchLocation = async () => {
    try {
      const response = await api.get(`/locations/${locationId}`);
      if (response.status === 200) setLocation(response.data.location);
    } catch (error) {
      console.log(error);
    }
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setLocation((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFenceChange = (event: SelectChangeEvent<number[]>) => {
    const {
      target: { value },
    } = event;
    setLocation((prev) => ({
      ...prev,
      location_fences: typeof value === 'string' ? value.split(',').map(Number) : value,
    }));
  };

  const removeFence = (fenceId: number) => {
    setLocation((prev) => ({
      ...prev,
      location_fences: (prev.location_fences || []).filter(id => id !== fenceId),
    }));
  };

  const onCoverImage = (e: any) => {
    uploadAsset(
      e,
      (fileName: string) => {
        setLocation({ ...location, location_image: fileName });
      },
      setUploading,
      setProgress
    );
  };


  // Location Name
  const onLocationNameLsPopOpen = () => {
    setLocationNamePop(true);
  };

  const onLocationNameLsPopClose = () => {
    setLocationNamePop(false);
  };

  const onSetLocationLs = (ls: any) => {
    setLocation({ ...location, location_name_ls: ls });
    setLocationNamePop(false);
  }


  // Location About Audio
  const onLocationAboutAudioPopOpen = () => {
    setLocationAboutAudioPop(true);
  };

  const onLocationAboutAudioPopClose = () => {
    setLocationAboutAudioPop(false);
  };

  const onSetLocationAboutAudio = (audio: any) => {
    setLocation({ ...location, location_audio_intro: audio });
    onLocationAboutAudioPopClose();
  };


  // Loaction Ext audio
  const onLocationExtAudioPopOpen = () => {
    setLocationExtendedAudioPop(true);
  };

  const onLocationExtAudioPopClose = () => {
    setLocationExtendedAudioPop(false);
  };

  const onSetLocationExtAudio = (audio: any) => {
    setLocation({ ...location, location_audio_extended: audio });
    onLocationExtAudioPopClose();
  };


  const onSubmit = async () => {
    if (!location.location_name.trim()) {
      Swal.fire({
        icon: 'error',
        title: 'Required Field',
        text: 'Location Name is mandatory.',
      });
      return;
    }

    const nameRegex = /^[a-zA-Z0-9 ]+$/;
    if (!nameRegex.test(location.location_name)) {
      Swal.fire({
        icon: 'warning',
        title: 'Invalid Name',
        text: 'Location Name can only contain letters, numbers, and spaces.',
      });
      return;
    }



    try {
      if (locationId !== "0") {
        await api.put(`/locations/${locationId}`, location);
        Swal.fire({
          icon: 'success',
          title: 'Updated!',
          text: 'Location updated successfully!',
          timer: 2000,
          showConfirmButton: false
        });
      } else {
        await api.post("/locations", location);
        Swal.fire({
          icon: 'success',
          title: 'Created!',
          text: 'Location created successfully!',
          timer: 2000,
          showConfirmButton: false
        });
      }
      navigate("/locations");
    } catch (error) {
      console.error("Failed to save location:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'An error occurred while saving the location.',
      });
    }
  };

  return (
    <>
      <div className="content-header pb-6">Location Name</div>
      <div className="content-body">
        <div className="flex flex-row gap-6 items-start">
          {/* Left Column */}
          <div className="flex-1 flex flex-col gap-4">
            <div className="flex flex-row items-center gap-2">
              <TextField
                variant="outlined"
                label="Location Name*"
                name="location_name"
                value={location.location_name}
                onChange={handleInputChange}
                fullWidth
              />
              <IconButton
                aria-label="Add space name in other languages"
                onClick={onLocationNameLsPopOpen}
              >
                <HiMiniLanguage className="l-icon" />
              </IconButton>
            </div>

            <TextField
              multiline
              variant="outlined"
              minRows={6}
              label="Description"
              name="location_desc"
              value={location.location_desc}
              onChange={handleInputChange}
              fullWidth
            />

            {/*<div className="flex flex-col gap-2">
              <div className="flex flex-wrap gap-2 mb-1">
                {(location.location_fences || []).map((fenceId) => {
                  const fence = allFences.find((f) => f.geo_fence_id === fenceId);
                  return (
                    <Chip
                      key={fenceId}
                      label={fence ? fence.geo_fence_name : `Fence ${fenceId}`}
                      onDelete={() => removeFence(fenceId)}
                      color="primary"
                      variant="outlined"
                    />
                  );
                })}
              </div>
              <FormControl fullWidth>
                <InputLabel id="fence-select-label">Select Geo Fences</InputLabel>
                <Select
                  labelId="fence-select-label"
                  id="fence-select"
                  multiple
                  value={location.location_fences || []}
                  onChange={handleFenceChange}
                  input={<OutlinedInput label="Select Geo Fences" />}
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {(selected as number[]).map((value) => (
                        <Chip
                          key={value}
                          label={allFences.find(f => f.geo_fence_id === value)?.geo_fence_name || value}
                          size="small"
                        />
                      ))}
                    </Box>
                  )}
                >
                  {allFences.map((fence) => (
                    <MenuItem key={fence.geo_fence_id} value={fence.geo_fence_id}>
                      <Checkbox checked={(location.location_fences || []).indexOf(fence.geo_fence_id!) > -1} />
                      <ListItemText primary={fence.geo_fence_name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>*/}

            {location.location_image && (
              <img
                src={`${ASSETS_PATH}/${location.location_image}`}
                alt=""
                className="w-full h-auto object-cover rounded-md"
              />
            )}
            {!location.location_image ? (
              <Button
                variant="outlined"
                component="label"
                fullWidth
              >
                *Upload Cover Image
                <input type="file" hidden onChange={onCoverImage} />
              </Button>
            ) : (
              <Button
                variant="outlined"
                color="error"
                fullWidth
                onClick={() => {
                  setLocation({ ...location, location_image: "" });
                }}
              >
                Remove cover image
              </Button>
            )}
          </div>

          {/* Right Column */}
          <div className="w-[300px] flex flex-col gap-4 sticky top-6">
            <div className="flex flex-row gap-2">
              <Button
                variant="contained"
                color="primary"
                onClick={onSubmit}
                className="flex-1"
                fullWidth
              >
                {locationId !== "0" ? "Update" : "Add"}
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate("/locations")}
                className="flex-1"
                fullWidth
              >
                Cancel
              </Button>
            </div>

            <Button
              variant="contained"
              color="inherit"
              onClick={onLocationAboutAudioPopOpen}
              fullWidth
              style={{ backgroundColor: '#f5f5f5', color: '#333' }}
            >
              Upload Intro Audio
            </Button>
            <Button
              variant="contained"
              color="inherit"
              onClick={onLocationExtAudioPopOpen}
              fullWidth
              style={{ backgroundColor: '#f5f5f5', color: '#333' }}
            >
              Upload Extended Audio
            </Button>
          </div>
        </div>
      </div>
      {uploading && <CircularWithValueLabel progress={progress} />}
      {locationNamePop &&
        createPortal(
          <PopLanguages
            fieldName={`Space Name`}
            languages={location.location_name_ls || {}}
            onSetLs={onSetLocationLs}
            onLangPopClose={onLocationNameLsPopClose}
          />,
          document.getElementById("modal") as HTMLElement
        )}
      {locationAboutAudioPop &&
        createPortal(
          <PopNarations
            narrations={location.location_audio_intro || {}}
            onSetNarrations={onSetLocationAboutAudio}
            onNarrationsPopClose={onLocationAboutAudioPopClose}
          />,
          document.getElementById("modal") as HTMLElement
        )}
      {locationExtendedAudioPop &&
        createPortal(
          <PopNarations
            narrations={location.location_audio_extended || {}}
            onSetNarrations={onSetLocationExtAudio}
            onNarrationsPopClose={onLocationExtAudioPopClose}
          />,
          document.getElementById("modal") as HTMLElement
        )}
    </>
  );
};

export default Location;
